import { render, staticRenderFns } from "./AppColumnPicker.vue?vue&type=template&id=646f27e4&"
import script from "./AppColumnPicker.vue?vue&type=script&lang=ts&"
export * from "./AppColumnPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports